"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormParent = void 0;
const react_1 = __importDefault(require("react"));
class FormParent extends react_1.default.Component {
}
exports.FormParent = FormParent;
//# sourceMappingURL=Form.types.js.map